import { FormSelectId } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../../../hooks';
import { useGraphneResourcesGroupListSuspense } from '../../../../../queryHooks/productionPlanHooks';
import { ResourceGroupWithExternalId } from '../../types';

export const BrigadeSelect = () => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan');
  const { data } = useGraphneResourcesGroupListSuspense();

  const options = data
    .filter((group): group is Required<ResourceGroupWithExternalId> => !!(group.externalId as { id?: number })?.id)
    .map((group) => {
      return {
        id: group.externalId.id,
        label: group.name,
      };
    });

  return (
    <FormSelectId
      required
      className="w-full"
      label={tWrapper('brigade')}
      maxWidth="full"
      name="workerGroupId"
      options={options}
      placeholder={t('common.select')}
    />
  );
};
